import { PageShell, RichText } from "@/components/site/PageShell";
import { Reveal } from "@/components/site/Reveal";
import { useSiteData } from "@/hooks/useSiteData";
import { useSeo } from "@/components/site/Seo";

export default function LegalPage({ doc, kind, testId }) {
  const { content } = useSiteData();
  useSeo({
    title: doc.title,
    description: kind === "privacy" ? "Kebijakan privasi BagiPulsa: data apa yang kami kumpulkan, bagaimana digunakan, dan bagaimana kami melindungi data pengguna layanan convert pulsa." : "Syarat dan ketentuan penggunaan layanan convert pulsa BagiPulsa, termasuk ketentuan transaksi, pencairan saldo, dan tanggung jawab pengguna.",
    path: kind === "privacy" ? "/privacy-policy" : "/syarat-ketentuan",
  });
  const body = content?.[kind] || doc.body;
  const updated = content?.[`${kind}_updated`] || doc.updated;
  return (
    <PageShell testId={testId}>
      <article className="mx-auto max-w-3xl px-5 pb-10">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">Berlaku sejak {updated}</p>
          <h1 className="mt-5 font-display text-4xl font-bold tracking-tight text-paper sm:text-5xl lg:text-6xl">{doc.title}</h1>
        </Reveal>
        <div className="mt-12 border-t border-white/10 pt-10">
          <RichText text={body} />
        </div>
      </article>
    </PageShell>
  );
}
